<template>
  <div class="left-chart-2">
    <div class="lc2-header">快递平台接单占比</div>
    <div class="lc2-details">快递平台总数<span>{{ companysTotal  }}</span></div>
<!--    <dv-charts class="lc2-chart" :option="option" />-->
    <div id="company"></div>
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'LeftChart2',
  props: {
    companys: {
      type: Array,
      default: () => []
    },
    companysTotal: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      echarts: null
    }
  },
  watch: {
    companys () {
      this.setOption()
    }
  },
  beforeDestroy () {
    this.echarts && this.echarts.dispose()
  },
  mounted () {
    this.echarts = echarts.init(document.getElementById('company'))
    this.setOption()
  },
  methods: {
    setOption () {
      let companys = this.companys.map(item => {
        return {
          name: item.companyName,
          value: item.totleCount
        }
      })
      let options = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: '0',
          orient: 'vertical',
          textStyle: { color: '#fff' }
        },
        series: [
          {
            name: '快递平台总数',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: companys
          }
        ]
      }
      this.echarts.setOption(options)
    }
  }
}
</script>

<style lang="less">
#company{
  width: 100%;
  height: 100%;
}
.left-chart-2 {
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: column;

  .lc2-header {
    height: 20px;
    line-height: 20px;
    font-size: 16px;
    text-indent: 20px;
    margin-top: 10px;
  }

  .lc2-details {
    height: 40px;
    font-size: 16px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc2-chart {
    height: calc(~"100% - 80px");
  }
}
</style>
